<template>
  <div>
    <el-row :gutter="20" type="flex">
      <el-col :span="10">
        <el-form ref="form" :model="formData" size="small" label-position="top">
          <div class="bf-section">
            <div class="form-section-title">
              <span>
                {{ $l('section_basic_info') || '基本信息' }}
              </span>
            </div>
            <el-row :gutter="12">
              <el-col :span="12">
                <el-form-item
                  :label="$l('form_label_transportNos') || '外运编号'"
                >
                  <el-input
                    v-model.trim="formData.transportNo"
                    :placeholder="
                      $l('form_placeholder_transportNos') || '请输入外运编号'
                    "
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$l('form_label_bookingType') || '订舱类型'"
                >
                  <dict-select
                    v-model="formData.bookingType"
                    url="/master/common/dict/biz"
                    :body="{ dictType: 'ECOM_BOOKING_TYPE' }"
                    :placeholder="
                      $l('form_placeholder_bookingType') || '请选择订舱类型'
                    "
                    filterable
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div class="form-section-title">
            <span>
              {{ $l('section_transport_info') || '运输信息' }}
            </span>
          </div>
          <el-row :gutter="12">
            <el-col :span="12">
              <el-form-item :label="$l('form_label_shipVoyage') || '船名航次'">
                <el-input
                  v-model.trim="formData.shipVoyage"
                  :placeholder="
                    $l('form_placeholder_shipVoyage') || '请输入船名航次'
                  "
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('form_label_domesticTransitScmCode') || '境内运输公司'
                "
              >
                <dict-select
                  v-model="formData.domesticTransitCode"
                  url="/master/common/dict/xzScmPartners"
                  :placeholder="
                    $l('form_placeholder_domesticTransitScmCode') ||
                      '请选择境内运输公司'
                  "
                  filterable
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('form_label_overseasTransitScmCode') || '境外运输公司'
                "
              >
                <dict-select
                  v-model="formData.overseasTransitCode"
                  url="/master/common/dict/xzScmPartners"
                  :placeholder="
                    $l('form_placeholder_overseasTransitScmCode') ||
                      '请选择境外运输公司'
                  "
                  filterable
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_dispatchPort') || '发运港口'"
              >
                <dict-select
                  v-model="formData.dispatchPort"
                  url="/master/port/select"
                  :placeholder="
                    $l('form_placeholder_dispatchPort') || '请选择发运港口'
                  "
                  filterable
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_destinationPortDetail') || '目的地港口'"
              >
                <dict-select
                  v-model="formData.destinationPort"
                  url="/master/port/select"
                  :placeholder="
                    $l('form_placeholder_destinationPort') || '请选择目的地港口'
                  "
                  filterable
                  clearable
                  style="width: 100%"
                  @loaded="(data) => (destinationPortItems = data)"
                  @change="onDestinationPortChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('form_label_deliveryPort') || '指运港'">
                <dict-select
                  v-model="formData.destinationPortFullName"
                  url="/master/port/fullNameSelect"
                  :placeholder="
                    $l('form_placeholder_deliveryPort') || '请选择指运港'
                  "
                  filterable
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_destinationCountry') || '目的国'"
              >
                <dict-select
                  v-model="formData.destinationCountry"
                  url="/master/port/countrySelect"
                  :placeholder="
                    $l('form_placeholder_destinationCountry') || '请选择目的国'
                  "
                  filterable
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item
                :label="$l('form_label_shipmentType') || '发运方式'"
              >
                <dict-select
                  v-model="formData.shipmentType"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'shipmentType' }"
                  :placeholder="
                    $l('form_placeholder_shipmentType') || '请选择发运方式'
                  "
                  filterable
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item
                :label="$l('form_label_quotedMethod') || '报价方式'"
              >
                <dict-select
                  v-model="formData.quotedMethod"
                  url="/sys/common/dict/system"
                  :body="{ dictType: 'quotedMethod' }"
                  :placeholder="
                    $l('form_placeholder_quotedMethod') || '请选择报价方式'
                  "
                  filterable
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$l('form_label_bookingDate') || '订舱日期'">
                <el-date-picker
                  v-model="formData.bookingDate"
                  :placeholder="
                    $l('form_placeholder_bookingDate') || '请选择订舱日期'
                  "
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('table_label_loadingDate') || '产装日期'"
              >
                <el-date-picker
                  v-model="formData.deliveryDate"
                  :placeholder="
                    $l('form_placeholder_loadingDate') || '请选择产装日期'
                  "
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_eta_detail') || '到港日期(ETA)'"
              >
                <el-date-picker
                  v-model="formData.eta"
                  :placeholder="
                    $l('form_placeholder_eta') || '请选择到港日期(ETA)'
                  "
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_fbaArrivalDate') || '到FBA日期'"
              >
                <el-date-picker
                  v-model="formData.fbaArrivalDate"
                  :placeholder="
                    $l('form_placeholder_fbaArrivalDate') || '请选择到FBA日期'
                  "
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_bookingScmCode') || '订舱货代'"
              >
                <dict-select
                  v-model="formData.bookingScmCode"
                  url="/master/common/dict/xzScmPartners"
                  :placeholder="
                    $l('form_placeholder_bookingScmCode') || '请选择订舱货代'
                  "
                  filterable
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_customsBrokerScmCode') || '报关货代'"
              >
                <dict-select
                  v-model="formData.customsBrokerScmCode"
                  url="/master/common/dict/xzScmPartners"
                  :placeholder="
                    $l('form_placeholder_customsBrokerScmCode') ||
                      '请选择报关货代'
                  "
                  filterable
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <div class="form-section-title">
            <span>
              {{ $l('section_receiver_sender') || '收发货人' }}
            </span>
          </div>
          <el-row :gutter="12">
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_shipperCode') || '发货人'"
                class="receiver-sender-item"
              >
                <dict-select
                  url="/factory/shipment/customer/select"
                  v-model="formData.shipperCode"
                  :body="{ shipmentType: 'S' }"
                  :placeholder="
                    $l('form_placeholder_shipperCode') || '请选择发货人'
                  "
                  filterable
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_consigneeCode') || '收货人'"
                class="receiver-sender-item"
              >
                <dict-select
                  url="/factory/shipment/customer/select"
                  v-model="formData.consigneeCode"
                  :body="{ shipmentType: 'C' }"
                  :placeholder="
                    $l('form_placeholder_consigneeCode') || '请选择收货人'
                  "
                  filterable
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_notifierCode') || '通知人'"
                class="receiver-sender-item"
              >
                <dict-select
                  url="/factory/shipment/customer/select"
                  v-model="formData.notifierCode"
                  :body="{ shipmentType: 'C' }"
                  :placeholder="
                    $l('form_placeholder_notifierCode') || '请选择通知人'
                  "
                  filterable
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>

      <el-col :span="14" class="booking-right-panel">
        <EditBookingContainer
          ref="bookingContainer"
          :shipmentCode="shipmentCode"
          :shipmentBookingCode="shipmentBookingCode"
          :listContainer="bookingContainers"
        />
      </el-col>
    </el-row>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import lodash from 'lodash'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import EditBookingContainer from '../edit-booking-container/index.vue'

export default {
  mixins: [EditLoading],
  components: { EditBookingContainer },
  props: {
    shipmentCode: { type: String, default: '' },
    shipmentBookingCode: { type: String, default: '' },
    listContainer: { type: Array, default: () => [] },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      destinationPortItems: [],
    }
  },
  computed: {
    bookingContainers() {
      if (!this.shipmentBookingCode && this.listContainer.length) {
        return this.listContainer
      }
      return this.formData.listContainer || []
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    onDestinationPortChange(value) {
      const item = lodash.find(this.destinationPortItems, { value })
      if (!item) return

      this.formData.destinationPortFullName = item.portFullName || ''
      this.formData.destinationCountry = item.portCountry || ''
    },
    async getData() {
      if (!this.shipmentBookingCode) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomShipmentBookingDetailApi({
          shipmentBookingCode: this.shipmentBookingCode,
        })
        .catch(() => null)
      this.loadingClose()

      this.formData = res?.body || {}
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const listContainer = this.$refs.bookingContainer.getListContainers()

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomShipmentBookingSaveApi({
          ...this.formData,
          shipmentCode: this.shipmentCode,
          listContainer,
        })
        .catch(() => null)
      this.loadingClose()

      if (!res) return

      const { status, msg } = res
      const error = status !== 200

      this.$message({
        showClose: true,
        message: msg,
        type: error ? 'error' : 'success',
      })
      if (error) return

      this.$emit('reload')
      this.close()
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.form-section-title {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  margin-top: 12px;
  margin-bottom: 8px;
}

.booking-right-panel {
  background: #f8fafc;
  border-left: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
}

::v-deep .receiver-sender-item {
  margin-bottom: 0;
}
</style>
